<template>
  <div>
    <el-select
     :placeholder="$t('Şəhər_Rayon')"
      filterable
      :value="selected"
      @input="handleInput"
      style="width: 100%"
    >
      <el-option
        v-for="item in data"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
      </el-option>
    </el-select>
  </div>
</template>
<script>
  import { GetRegions } from "../../services/cls";
  export default {
    props: {
      value: [Number, String],
    },
    data() {
      return {
        data: [],
        selected: this.value,
      };
    },
    watch: {
      value(newVal) {
        this.selected = newVal;
      }
    },
    methods: {
       setRegionFromSearch(searchName) {
    if (!searchName || !this.data.length) return;
    
    const foundRegion = this.data.find(region => 
      region.name.toLowerCase().includes(searchName.toLowerCase()) ||
      searchName.toLowerCase().includes(region.name.toLowerCase())
    );
    
    if (foundRegion) {
      this.selected = foundRegion.id;
      this.$emit('input', foundRegion.id);
      this.$emit('region', foundRegion.name);
    }
  },
      handleInput(e) {
        this.selected = e;
        this.$emit("input", e);
        const selectedRegion = this.data.find(item => item.id === e);
        if (selectedRegion) {
          this.$emit("region", selectedRegion.name);
        }
      },
      getData() {
        GetRegions().then((response) => {
          if (response.data.data) {
            this.data = response.data.data;
            // If there's a value but selected isn't set
            if (this.value && !this.selected) {
              this.selected = this.value;
            }
          } else {
            this.$message({
              type: "error",
              message: "Regions: No data found!",
            });
          }
        });
      },
    },
    mounted() {
      this.getData();
    },
  };
  </script>

<style lang="scss" scoped>
</style>